import React, { forwardRef } from 'react';
import '../ReusableButton/ReusableButton.css';
import './NoOutlineTextButton.css';

const VALID_SIZES = new Set(['sm', 'md', 'lg']);

function classNames(...parts) {
  return parts.filter(Boolean).join(' ');
}

function normalizeSize(size) {
  if (size == null || size === '') return 'md';
  const s = String(size).trim().toLowerCase();
  if (VALID_SIZES.has(s)) return s;
  return 'md';
}

/**
 * Borderless text button: dark gray regular text, no background or underline; brand bronze on hover only (no size/layout shift).
 *
 * @param {object} props
 * @param {React.ReactNode} props.children — label text
 * @param {React.ReactNode} [props.iconPrefix] — icon before text (e.g. `<FiArrowLeft />`)
 * @param {'sm' | 'md' | 'lg'} [props.size='md']
 * @param {boolean} [props.fullWidth]
 * @param {string} [props.className]
 * @param {boolean} [props.disabled]
 * @param {'button' | 'submit' | 'reset'} [props.type='button']
 */
const NoOutlineTextButton = forwardRef(function NoOutlineTextButton(
  {
    children,
    iconPrefix,
    size = 'md',
    fullWidth = false,
    className,
    disabled = false,
    type = 'button',
    ...rest
  },
  ref
) {
  const sizeKey = normalizeSize(size);
  const hasLabel = children != null && children !== '';

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={classNames(
        'notb-btn',
        `notb-btn--${sizeKey}`,
        fullWidth && 'notb-btn--full',
        className
      )}
      {...rest}
      data-notb=""
    >
      {iconPrefix ? (
        <span className="notb-btn__icon" aria-hidden={hasLabel ? true : undefined}>
          {iconPrefix}
        </span>
      ) : null}
      {hasLabel ? <span className="notb-btn__label">{children}</span> : null}
    </button>
  );
});

NoOutlineTextButton.displayName = 'NoOutlineTextButton';

export default NoOutlineTextButton;
